<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegationsSelected"
            :options="delegations"
            optionValue="id"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
          />
        </PCol>
        <PCol md="12" v-if="clienteSelected?.pais.hasTransportadora">
          <PFormSelectMulti
            v-model="valueLocal.transportadorasSelected"
            :options="transportadorasOptions"
            optionValue="id"
            optionText="descripcion"
            :label="$t('label.transportadora')"
            :placeholder="$t('option.select')"
          />
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.pkCoste"
            :options="getCostes"
            optionValue="id"
            optionText="desParametro"
            :label="$t('label.coste')"
            :placeholder="$t('option.select')"
          />
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.denominacionesSelected"
            :options="getDenominaciones"
            optionValue="key"
            optionText="value"
            :label="$t('label.denominaciones')"
            :placeholder="$t('option.select')"
          />
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  ICliente,
  IDelegacion,
  IDivisa,
  IParametro,
  ITransportadora,
  KeyValuePair,
} from "@/entities";
import { ITransferenciasQuickFilter } from "@/pages/transferencias/types";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";

@Component({
  mixins: [VueMethods],
})
export class TransferenciasPublicasFiltersForm extends Vue {
  @Prop({ required: true }) value!: any;
  @Prop({ required: true }) transportadorasOptions!: ITransportadora[];
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.value) this.valueLocal = JSON.parse(JSON.stringify(this.value));
  }
  valueLocal = {
    delegationsSelected: [],
    pkCoste: [],
    denominacionesSelected: [],
    transportadorasSelected: [],
  };
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getLocale") locale!: Locale;
  @Getter("getClienteSelected") clienteSelected!: ICliente;
  @Getter("getCostes") getCostes!: IParametro[];
  @Getter("getClienteXDivisa") getClienteXDivisa!: IDivisa[];
  @Getter("getTransferenciasPageQuickFilter")
  getTransferenciasPageQuickFilter!: ITransferenciasQuickFilter;

  validado = false;

  get getDenominaciones(): KeyValuePair[] {
    const divisas = this.getTransferenciasPageQuickFilter.divisa.length
      ? this.getTransferenciasPageQuickFilter.divisa
      : this.getClienteXDivisa;

    const calidades: KeyValuePair[] = [];
    divisas.forEach((divisa) => {
      divisa.denominaciones?.sort((a, b) => this.sortDescending(a, b, "numValue"));
      divisa.denominaciones?.forEach((denominacion) =>
        denominacion.calidades?.forEach((calidad) =>
          calidades.push({
            key: calidad.id.toString(),
            value: `${calidad.denominacion?.codDenominacion} ${calidad.desCalidad}`,
          })
        )
      );
    });
    return calidades;
  }
  initialValueLocal = {
    delegationsSelected: [],
    pkCoste: [],
    denominacionesSelected: [],
    transportadorasSelected: [],
  };

  get delegations(): IDelegacion[] {
    let delegationsList: IDelegacion[] = [];
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) delegationsList.push(clientexdel.delegacion);
    });
    return delegationsList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }

  limpiar(): void {
    this.valueLocal.delegationsSelected = [];
    this.valueLocal.pkCoste = [];
    this.valueLocal.denominacionesSelected = [];
    this.valueLocal.transportadorasSelected = [];
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { data: this.valueLocal, action: action });
  }
}
export default TransferenciasPublicasFiltersForm;
</script>
